import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();
  return <IconButton type='add' fontSize='medium' color='transparent' tooltip={t('AutomaticStateTransitions.Add')} onClick={onAdd} />;
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
